var _style, _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEventAvailableBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.2 40.3",
    style: {
      enableBackground: "new 0 0 38.2 40.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#484D63;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.2,32.4 10.7,25.9 13.4,23.2 17.3,27 25,19.3 27.7,22 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.6,7.2C33.9,6.5,33,6.1,32,6.1h-1.8V2.4h-3.7v3.7H11.8V2.4H8.1v3.7H6.3c-1,0-1.9,0.3-2.6,1 C3,7.8,2.6,8.7,2.6,9.7v25.7c0,1,0.4,1.9,1.1,2.6c0.7,0.7,1.6,1.1,2.6,1.1h25.6c1,0,1.9-0.4,2.6-1.1c0.7-0.7,1.1-1.6,1.1-2.6V9.7 C35.6,8.7,35.2,7.9,34.6,7.2z M32,35.4H6.3V17.1H32V35.4z M32,13.4H6.3V9.7H32V13.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventAvailableBig);
export default __webpack_public_path__ + "static/media/icon_event_available_big.5eabdf830f19f8accee91197185cb024.svg";
export { ForwardRef as ReactComponent };